import React from 'react'
import chatBot from '../../../media/chatBot.webp';
import Template from '../template/Template';
const ReactNative = (props) => {
    const Css = {
        "--background": `${props.isValue ? props.mode : 'red'}`
    }
    return (
        <div className="bodyCon projectCon">
            <div className="bodyComponent">
                <div className="aboutHeading projectHeading" style={Css}>
                    <h1>React Native</h1>
                    <div className="container">
                        <div className="projects">
                            <a href='https://github.com/Zer-0ne/zChat-react-native' target='_blank' rel="noreferrer">
                                <Template img={chatBot} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReactNative
